import { getWeekStartByLocale } from 'weekstart';

import {
  getRegionalFormat,
  getTimezone,
} from '@dynatrace-sdk/user-preferences';

import { Days } from '../components/Days.js';
import { Weekdays } from '../components/Weekdays.js';
import { DayViewContextProvider } from '../contexts/DayViewContext.js';

/**
 * SelectDayView component
 * Renders a grid of buttons for selecting the day, with localized weekday labels.
 * @internal
 */
export const SelectDayView = () => {
  const region = getRegionalFormat();
  const weekStartsOn = getWeekStartByLocale(region);

  // Extract the user-settings timezone to use for the calculation
  const configuredTimezone = getTimezone();

  return (
    <>
      <Weekdays
        weekStartsOn={weekStartsOn}
        configuredTimezone={configuredTimezone}
      />
      <DayViewContextProvider>
        <Days weekStartsOn={weekStartsOn} />
      </DayViewContextProvider>
    </>
  );
};

SelectDayView['displayName'] = 'SelectDayView';
